import {store} from "../../helper/store";
import {isNull} from "../../utils/utils";
import {updateAbstractAppsInstalled} from "../../redux_actions/morpheus.setting.action";

export const checkAbstractAppPermission = app => {
    let morpheusState = store.getState().morpheusSettingReducer;
    let abstract_configs = morpheusState?.abstract_configs;
    if (!abstract_configs || isNull(abstract_configs)) return false;
    let appId = app && app.id;
    if (!appId || isNull(appId)) return false;
    if (isNull(abstract_configs[appId])) {
        abstract_configs[app.id] = app.defaultPermission || false;
        store.dispatch(updateAbstractAppsInstalled(abstract_configs));
    }
    app.permission = abstract_configs[app.id];
    return app.permission;
}

export const getAbstractConfigValue = (app, value) => {
    let morpheusState = store.getState().morpheusSettingReducer;
    let abstract_configs = morpheusState?.abstract_configs;
    if (!abstract_configs || isNull(abstract_configs)) return value;
    let appId = app && app.id;
    if (!appId || isNull(appId)) return value;
    if (isNull(abstract_configs[appId])) {
        abstract_configs[app.id] = {
            value: value
        };
        store.dispatch(updateAbstractAppsInstalled(abstract_configs));
    }
    app.value = abstract_configs[app.id]['value'] || value;
    return app.value;
}


/*
Abstract Apps
Abstract apps are apps that are not directly related to the viewer.
Abstract apps are more closely related to all the miscellaneous morpheus settings.
*/


export const autoExportPostScanApp = {
    id: "autoExportPostScan",
    defaultPermission: false
}

export const defaultDigitalZoomOn = {
	id: "defaultDigitalZoomOn",
	defaultPermission: false
}

export const showParallelGateOpen = {
    id: "showParallelGateOpen",
    defaultPermission: false
}

export const specimenBasedViewerSettingApp = {
    id: "specimenBasedViewerSetting",
    defaultPermission: false
}

export const showAnnotationsLabel = {
    id: "showAnnotationsLabel",
    defaultPermission: true,
}

// Dont add to getAbstractApps() function, not something we want to expose to users
export const annoLabelFont = {
    id: "annoLabelFont",
    defaultPermission: false,
    value: 20,
}

export const lockCapReport = {
    id: "lockCapReport",
    defaultPermission: false,
}

export const showMfaAlert = {
    id: "showMfaAlert",
    defaultPermission: true,
}

export const launchOnCasePage = {
    id: "launchOnCasePage",
    defaultPermission: false,
}

export const demoModeOn = {
    id: "demoModeOn",
    defaultPermission: false,
}

export const getAbstractApps = () => {
    return [
        autoExportPostScanApp,
        lockCapReport,
        defaultDigitalZoomOn,
        showAnnotationsLabel,
        annoLabelFont,
        showMfaAlert,
        demoModeOn,
        launchOnCasePage
    ]
}